import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { CommunicatorMessageType, Template } from '@quorum/models/xs-resource';
import { RouterStateService } from '@quorum/sha-router';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { TemplatesFacade } from '@quorum/xsr-template-library';
import { AuthenticatedUser } from 'libs/authentication/src/lib/+state/authentication.interfaces';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
@Component({
  selector: 'quorum-new',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.scss'],
})
export class NewComponent implements OnInit {
  filteredMessageTypes$: Observable<CommunicatorMessageType[]>;
  source: string;
  templateForm: FormGroup = new FormGroup({
    name: new FormControl(null, Validators.required),
    description: new FormControl(null, Validators.required),
    messageTypeId: new FormControl(null, Validators.required),
    subject: new FormControl(null, Validators.required),
  });
  sourceTemplate: Template;
  sourceTemplateSelectedLanguage: string;
  user: AuthenticatedUser;
  constructor(
    private authenticationStateService: AuthenticationStateService,
    private routerStateService: RouterStateService,
    private systemControlStateService: SystemControlStateService,
    public templateFacade: TemplatesFacade
  ) {}

  ngOnInit(): void {
    this.authenticationStateService
      .selectAuthenticatedUser()
      .pipe(
        filter((user) => user != null),
        take(1)
      )
      .subscribe((user) => {
        this.user = user;

        this.routerStateService
          .selectRouterState()
          .pipe(take(1))
          .subscribe((routerState) => {
            let queryParams = routerState.state.root.queryParams;
            this.sourceTemplateSelectedLanguage = queryParams.language;
            switch (queryParams.from) {
              case 'dealerGallery':
                this.source = 'Dealer Gallery';
                this.templateFacade.storeGallery$
                  .pipe(
                    filter((templates) => templates && templates.length > 0),
                    take(1),
                    map((templates) => templates.find((template) => template.id === queryParams.id))
                  )
                  .subscribe((sourceTemplate) => {
                    this.sourceTemplate = new Template({
                      ...sourceTemplate,
                      createdFromTemplateId: queryParams.id,
                    });
                  });
                break;
              case 'quorumGallery':
                this.source = 'Quorum Gallery';
                this.templateFacade.quorumGallery$
                  .pipe(
                    filter((templates) => templates && templates.length > 0),
                    take(1),
                    map((templates) => templates.find((template) => template.id === queryParams.id))
                  )
                  .subscribe((sourceTemplate) => {
                    this.sourceTemplate = new Template({
                      ...sourceTemplate,
                      createdFromTemplateId: queryParams.id,
                    });
                  });
                break;
              case 'scratch':
                this.source = 'Scratch';
                this.sourceTemplate = new Template({});
              default:
                break;
            }
          });
      });

    this.authenticationStateService
      .selectAuthenticatedEmployee()
      .pipe(
        filter((employee) => employee != null),
        take(1)
      )
      .subscribe((employee) => {
        this.systemControlStateService
          .getSystemControlValue('CL_BODY_SHOP_DEALER', employee.rooftopId)
          .pipe(
            take(1),
            map((sctValue) => (sctValue == '' || null ? false : true))
          )
          .subscribe((bodyShopDealer) => {
            this.filteredMessageTypes$ = this.templateFacade.messageTypes$.pipe(
              map((messageTypes) =>
                bodyShopDealer
                  ? messageTypes
                  : messageTypes.filter((messageType) => messageType.description.includes(`(Body Shop)`))
              )
            );
          });
      });
  }

  create(template: Template, templateForm: any) {
    this.templateFacade.messageTypes$
      .pipe(
        take(1),
        map((messageTypes) => messageTypes.find((m) => m.id.toString() === templateForm.messageTypeId.toString()))
      )
      .subscribe((messageType: CommunicatorMessageType) => {
        let newTemplate = new Template({ ...template });
        newTemplate.messageTypeId = templateForm.messageTypeId;
        newTemplate.transactionTypeId = messageType.transactionTypeId;

        this.templateFacade.selectedLanguage$.pipe(take(1)).subscribe((selectedLanguage) => {
          if (newTemplate.languageDefinitionMap) {
            Object.keys(newTemplate.languageDefinitionMap).forEach((language) => {
              newTemplate.languageDefinitionMap[language] = {
                ...newTemplate.languageDefinitionMap[language],
                name: templateForm.name,
                description: templateForm.description,
                subject: templateForm.subject,
              };
            });
          } else {
            newTemplate.languageDefinitionMap = {
              [selectedLanguage]: {
                name: templateForm.name,
                description: templateForm.description,
                subject: templateForm.subject,
                html: '<html></html>',
                mjml: '<mjml><mj-body></mj-body></mjml>',
                previewImageUrl: 'https://',
              },
            };
          }

          this.templateFacade.createStoreGalleryTemplate(this.user.user.destination, newTemplate);
        });
      });
  }
}
